import { useState, useEffect } from "react";

/**
 * Form chỉnh sửa tin đăng bất động sản
 */
export default function EditPostPropertyForm({
    formData,
    setFormData,
    imageFiles = [],
    setImageFiles,
    uploading,
    handleChange,
    handleFileChange,
    handleRemoveImage,
    handleSubmit,
    existingImages = [],
    setExistingImages = () => { },
}) {
    const [errors, setErrors] = useState({});

    const amenitiesList = [
        "Hồ bơi", "Gym", "Khu vui chơi", "Bảo vệ 24/7",
        "Bãi đỗ xe", "Thang máy", "Sân vườn", "BBQ",
        "Trung tâm thương mại", "Công viên", "Trường học"
    ];

    const inputClass = "mt-1 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out";

    useEffect(() => {
        return () => {
            imageFiles.forEach(file => URL.revokeObjectURL(file.preview));
        };
    }, [imageFiles]);

    const validate = () => {
        const newErrors = {};
        if (!formData.title?.trim()) newErrors.title = "Vui lòng nhập tiêu đề bất động sản";
        if (!formData.projectName?.trim()) newErrors.projectName = "Vui lòng nhập tên dự án";
        if (!formData.propertyType) newErrors.propertyType = "Vui lòng chọn loại bất động sản";
        if (!formData.area || formData.area <= 0) newErrors.area = "Vui lòng nhập diện tích hợp lệ";
        if (formData.transactionType === "sale" && (!formData.price || formData.price <= 0)) newErrors.price = "Vui lòng nhập giá bán hợp lệ";
        if (formData.transactionType === "rent" && (!formData.rentPrice || formData.rentPrice <= 0)) newErrors.rentPrice = "Vui lòng nhập giá thuê hợp lệ";
        if (formData.bedrooms == null || formData.bedrooms < 0) newErrors.bedrooms = "Vui lòng nhập số phòng ngủ hợp lệ";
        if (formData.bathrooms == null || formData.bathrooms < 0) newErrors.bathrooms = "Vui lòng nhập số phòng tắm hợp lệ";
        if (!formData.location?.trim()) newErrors.location = "Vui lòng nhập địa điểm";
        if (existingImages.length + imageFiles.length === 0) newErrors.images = "Vui lòng chọn ít nhất 1 ảnh bất động sản";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmitWrapper = e => {
        e.preventDefault();
        if (!validate()) return;

        const updatedForm = {
            ...formData,
            amenities: formData.amenities
                ? typeof formData.amenities === "string"
                    ? formData.amenities.split(",").map(a => a.trim()).filter(a => a)
                    : formData.amenities
                : [],
        };

        handleSubmit(updatedForm);
    };

    return (
        <div className="max-w-5xl mx-auto p-8 bg-gray-50 shadow-2xl rounded-xl mt-8">
            <div className="text-2xl font-serif font-bold tracking-widest uppercase mb-6">
                <span className="text-[#0c2c4d]">Chỉnh sửa tin</span> <span className="text-[#c9a063]">bất động sản</span>
            </div>
            <form onSubmit={handleSubmitWrapper} className="space-y-8">

                {/* --- Thông tin cơ bản --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">1. Thông Tin Cơ Bản</h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block font-semibold text-gray-700 mb-1">Tên dự án <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="projectName"
                                value={formData.projectName || ""}
                                onChange={handleChange}
                                className={inputClass}
                                placeholder="Ví dụ: Vinhomes Grand Park"
                            />
                            {errors.projectName && <p className="text-red-500 text-sm mt-1">{errors.projectName}</p>}
                        </div>

                        <div>
                            <label className="block font-semibold text-gray-700 mb-1">Tiêu đề tin <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title || ""}
                                onChange={handleChange}
                                className={inputClass}
                                placeholder="Ví dụ: Căn hộ 2PN view đẹp, giá tốt"
                            />
                            {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="block font-semibold text-gray-700 mb-1">Loại bất động sản <span className="text-red-500">*</span></label>
                            <select
                                name="propertyType"
                                value={formData.propertyType || ""}
                                onChange={handleChange}
                                className={inputClass}
                            >
                                <option value="">-- Chọn loại --</option>
                                <option value="apartment">Căn hộ</option>
                                <option value="villa">Biệt thự</option>
                                <option value="shophouse">Shophouse</option>
                                <option value="condotel">Condotel</option>
                                <option value="penthouse">Penthouse</option>
                                <option value="duplex">Duplex</option>
                            </select>
                            {errors.propertyType && <p className="text-red-500 text-sm mt-1">{errors.propertyType}</p>}
                        </div>

                        <div>
                            <label className="block font-semibold text-gray-700 mb-1">Loại giao dịch *</label>
                            <select
                                name="transactionType"
                                value={formData.transactionType || "sale"}
                                onChange={handleChange}
                                className={inputClass}
                            >
                                <option value="sale">Bán</option>
                                <option value="rent">Cho thuê</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* --- Chi tiết căn hộ và giá --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">2. Chi Tiết & Giá</h3>

                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block font-medium text-gray-700">Block / Phân khu</label>
                            <input type="text" name="block" value={formData.block || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: B2" />
                        </div>
                        <div>
                            <label className="block font-medium text-gray-700">Mã căn</label>
                            <input type="text" name="unitCode" value={formData.unitCode || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: B2-0501" />
                        </div>
                        <div>
                            <label className="block font-medium text-gray-700">Tầng</label>
                            <input type="number" name="floor" value={formData.floor || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 5" />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="block font-medium text-gray-700">Phòng ngủ</label>
                            <input type="number" name="bedrooms" value={formData.bedrooms || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 2" min="0" />
                        </div>
                        <div>
                            <label className="block font-medium text-gray-700">Phòng WC</label>
                            <input type="number" name="bathrooms" value={formData.bathrooms || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 2" min="0" />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="block font-semibold text-gray-700">Diện tích (m²) <span className="text-red-500">*</span></label>
                            <input type="number" name="area" value={formData.area || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 80" min="1" />
                            {errors.area && <p className="text-red-500 text-sm mt-1">{errors.area}</p>}
                        </div>

                        {formData.transactionType === "sale" ? (
                            <div>
                                <label className="block font-semibold text-gray-700">Giá bán (VND)</label>
                                <input type="number" name="price" value={formData.price || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 3,000,000,000" min="0" />
                                {errors.price && <p className="text-red-500 text-sm mt-1">{errors.price}</p>}
                            </div>
                        ) : (
                            <div>
                                <label className="block font-semibold text-gray-700">Giá thuê (VND)</label>
                                <input type="number" name="rentPrice" value={formData.rentPrice || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 20,000,000" min="0" />
                                {errors.rentPrice && <p className="text-red-500 text-sm mt-1">{errors.rentPrice}</p>}
                            </div>
                        )}
                    </div>
                </div>

                {/* --- Trạng thái & Địa chỉ --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">3. Trạng Thái & Vị Trí</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block font-medium text-gray-700 mb-1">Tình trạng nội thất</label>
                            <select name="furniture" value={formData.furniture || "none"} onChange={handleChange} className={inputClass}>
                                <option value="full">Đầy đủ (Full Furniture)</option>
                                <option value="basic">Cơ bản (Basic Furniture)</option>
                                <option value="none">Không có (Raw)</option>
                            </select>
                        </div>

                        <div>
                            <label className="block font-medium text-gray-700 mb-1">Tình trạng bàn giao</label>
                            <select name="handoverStatus" value={formData.handoverStatus || "basic"} onChange={handleChange} className={inputClass}>
                                <option value="raw">Thô</option>
                                <option value="basic">Hoàn thiện cơ bản</option>
                                <option value="furnished">Đầy đủ nội thất</option>
                            </select>
                        </div>

                        <div>
                            <label className="block font-medium text-gray-700 mb-1">Nguồn tin</label>
                            <select name="isPrimary" value={formData.isPrimary ? "true" : "false"} onChange={(e) => setFormData(prev => ({ ...prev, isPrimary: e.target.value === "true" }))} className={inputClass}>
                                <option value="false">Ký gửi (Thứ cấp)</option>
                                <option value="true">Hàng chủ đầu tư (Sơ cấp)</option>
                            </select>
                        </div>
                    </div>

                    <div className="mt-4">
                        <label className="block font-semibold text-gray-700 mb-1">Địa chỉ / Vị trí <span className="text-red-500">*</span></label>
                        <input type="text" name="location" value={formData.location || ""} onChange={handleChange} className={inputClass} placeholder="Số nhà, đường, quận/huyện, tỉnh/thành phố" />
                        {errors.location && <p className="text-red-500 text-sm mt-1">{errors.location}</p>}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="block font-medium text-gray-700">Hướng view</label>
                            <input type="text" name="view" value={formData.view || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: View sông, hồ, nội khu" />
                        </div>
                        <div>
                            <label className="block font-medium text-gray-700">Tình trạng pháp lý</label>
                            <input type="text" name="legalStatus" value={formData.legalStatus || "Sổ hồng lâu dài"} onChange={handleChange} className={inputClass} placeholder="Ví dụ: Sổ hồng lâu dài, hợp đồng mua bán" />
                        </div>
                    </div>
                </div>

                {/* --- Tiện ích & Mô tả --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">4. Tiện Ích & Mô Tả</h3>

                    <div className="mb-6">
                        <label className="block font-medium text-gray-700 mb-2">Tiện ích</label>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                            {amenitiesList.map((amenity) => (
                                <label key={amenity} className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg cursor-pointer hover:bg-blue-50 transition duration-150 ease-in-out">
                                    <input
                                        type="checkbox"
                                        checked={formData.amenities?.includes(amenity)}
                                        onChange={() => {
                                            setFormData(prev => {
                                                const exists = prev.amenities?.includes(amenity);
                                                return {
                                                    ...prev,
                                                    amenities: exists
                                                        ? prev.amenities.filter(a => a !== amenity)
                                                        : [...(prev.amenities || []), amenity]
                                                };
                                            });
                                        }}
                                        className="form-checkbox text-blue-600 rounded"
                                    />
                                    <span className="text-sm text-gray-700">{amenity}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div>
                        <label className="block font-medium text-gray-700 mb-1">Mô tả chi tiết</label>
                        <textarea name="description" value={formData.description || ""} onChange={handleChange} className={`${inputClass} h-32`} placeholder="Nêu bật các điểm mạnh, chính sách bán hàng và thông tin liên hệ." />
                    </div>
                </div>

                {/* --- Ảnh bất động sản --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">5. Hình Ảnh</h3>
                    <input type="file" multiple accept="image/*" onChange={handleFileChange} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                    {errors.images && <p className="text-red-500 text-sm mt-1">{errors.images}</p>}

                    {imageFiles.length > 0 && (
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-4">
                            {imageFiles.map((file, i) => (
                                <div key={i} className="relative group overflow-hidden rounded-lg shadow-lg">
                                    <img src={URL.createObjectURL(file)} alt={`Property Image ${i + 1}`} className="w-full h-32 object-cover transition duration-300 group-hover:scale-105" />
                                    <button type="button" onClick={() => handleRemoveImage(i)} className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full opacity-90 hover:opacity-100 transition duration-150 ease-in-out">✕</button>
                                </div>
                            ))}
                        </div>
                    )}

                    {existingImages.length > 0 && (
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-4">
                            {existingImages.map((imgUrl, i) => (
                                <div key={i} className="relative group overflow-hidden rounded-lg shadow-lg">
                                    <img src={imgUrl} alt={`Existing Image ${i + 1}`} className="w-full h-32 object-cover transition duration-300 group-hover:scale-105" />
                                    <button type="button" onClick={() => setExistingImages(prev => prev.filter((_, idx) => idx !== i))} className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full opacity-90 hover:opacity-100 transition duration-150 ease-in-out">✕</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* --- Trạng thái bán --- */}
                <div>
                    <label className="block font-medium text-gray-700 mb-1">Trạng thái bán</label>
                    <div className="flex items-center gap-4">
                        <label className="flex items-center gap-1">
                            <input type="radio" name="isSold" value="true" checked={!!formData.isSold} onChange={() => setFormData(prev => ({ ...prev, isSold: true }))} />
                            Đã bán
                        </label>
                        <label className="flex items-center gap-1">
                            <input type="radio" name="isSold" value="false" checked={!formData.isSold} onChange={() => setFormData(prev => ({ ...prev, isSold: false }))} />
                            Chưa bán
                        </label>
                    </div>
                </div>

                <button type="submit" className="w-full bg-blue-600 text-white font-bold text-lg px-6 py-3 rounded-xl shadow-lg hover:bg-blue-700 transition duration-200 ease-in-out disabled:bg-gray-400" disabled={uploading}>
                    {uploading ? "Đang cập nhật..." : "Cập nhật"}
                </button>
            </form>
        </div>
    );
}
